import { Notice } from '@bufferapp/ui'
import styled from 'styled-components'

export const StyledNotice = styled(Notice)`
  border-radius: 8px;
  width: 100%;
  position: absolute;
  top: -8px;
  transform: translateY(-100%);
`

export const IdeatorHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  padding: 24px 40px 0 40px;
  position: relative;
`

export const IdeaTitleInput = styled.input`
  all: unset;
  margin: 20px 0 8px;
  padding: 4px 0;
  font-size: 18px;
  line-height: 28px;
  font-weight: 600;
  border: none;
  border-radius: 4px;
  color: var(--color-text-neutral);

  ::placeholder {
    color: var(--color-text-subtle);
  }
`

export const IdeatorContent = styled.div`
  margin: 8px 40px 40px 40px;
  flex-grow: 1;
  font-size: 16px;
  line-height: 28px;
  color: var(--color-text-neutral);
  overflow-y: auto;
  position: relative;

  [data-slate-placeholder='true'] {
    color: var(--color-text-subtle);
    --composer-placeholder-top: 0px;
  }

  &::-webkit-scrollbar-track {
    background: var(--color-bg-neutral);
  }

  a {
    color: var(--color-text-brand);
    &:hover {
      text-decoration: underline;
    }
  }
`

export const MediaManagerWrapper = styled.div`
  position: relative;

  #media-manager {
    padding: 0 40px;
  }
`

export const IntegrationsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 40px 12px 40px;
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--space-md);
  padding: 20px 40px;
  border-top: 1px solid var(--color-border-subtle);
`
